import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteConfig } from '../mock';
import NavbarDropdown from './NavbarDropdown';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const servicosItems = [
    { path: '/meta-ads', label: 'Tráfego Pago META' },
    { path: '/google-ads', label: 'Tráfego Pago GOOGLE' },
    { path: '/tiktok-taboola', label: 'Tráfego Pago TIKTOK ADS/TABOOLA' },
    { path: '/social-media', label: 'Social Media Completo' },
    { path: '/social-media-vitrine', label: 'Social Media Vitrine' },
    { path: '/ensaios-foodporn', label: 'Ensaios Foto/Vídeo (FoodPorn)' },
    { path: '/ensaios-casual', label: 'Ensaios Foto/Vídeo (Casual/Dia a Dia)' },
    { path: '/engenharia-cardapio', label: 'Engenharia e Reestruturação de Cardápio' },
    { path: '/fotos-cardapio', label: 'Fotos Remasterizadas para Cardápio (FoodPorn)' },
    { path: '/edicao', label: 'Edição/Criação de Conteúdo' },
    { path: '/copy-roteiros', label: 'Roteiros e Copys que Vendem' }
  ];

  const escolaItems = [
    { path: '/escola-empreendedor', label: 'Dominando o Ifood - Oalexandreneto' }
  ];

  const whatsappLink = `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent('Quero fechar a CompreCliente.')}`;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={`${process.env.PUBLIC_URL}/assets/logo-comprecliente.png`}
              alt="CompreCliente"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className={`text-base font-normal transition-all duration-300 ${location.pathname === '/'
                ? 'text-white'
                : 'text-gray-400 hover:text-white'
                }`}
            >
              Início
            </Link>

            <Link
              to="/assessoria-comercial"
              className={`text-base font-normal transition-all duration-300 ${location.pathname === '/assessoria-comercial'
                ? 'text-white'
                : 'text-gray-400 hover:text-white'
                }`}
            >
              Assessoria Comercial
            </Link>

            <NavbarDropdown title="Serviços" items={servicosItems} />

            <NavbarDropdown title="Escola do Empreendedor" items={escolaItems} />

            <Link
              to="/contato"
              className={`text-base font-normal transition-all duration-300 ${location.pathname === '/contato'
                ? 'text-white'
                : 'text-gray-400 hover:text-white'
                }`}
            >
              Contato
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 text-black font-medium rounded-lg transition-all duration-300 hover:scale-105"
              style={{ backgroundColor: siteConfig.colors.gold }}
            >
              Falar no WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 space-y-2 max-h-[80vh] overflow-y-auto">
            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className="block py-2 text-base text-gray-400 hover:text-white"
            >
              Início
            </Link>

            <Link
              to="/assessoria-comercial"
              onClick={() => setIsMenuOpen(false)}
              className="block py-2 text-base text-gray-400 hover:text-white"
            >
              Assessoria Comercial
            </Link>

            <div className="py-2">
              <p className="text-[#D4AF37] font-semibold text-sm mb-2">Serviços</p>
              {servicosItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="block py-2 pl-4 text-sm text-gray-400 hover:text-white"
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <div className="py-2">
              <p className="text-[#D4AF37] font-semibold text-sm mb-2">Escola do Empreendedor</p>
              {escolaItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="block py-2 pl-4 text-sm text-gray-400 hover:text-white"
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <Link
              to="/contato"
              onClick={() => setIsMenuOpen(false)}
              className="block py-2 text-base text-gray-400 hover:text-white"
            >
              Contato
            </Link>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center px-6 py-3 text-black font-medium rounded-lg mt-4"
              style={{ backgroundColor: siteConfig.colors.gold }}
            >
              Falar no WhatsApp
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
